module.exports = __webpack_public_path__ + "img/access-levels-operations.8fbf4e91.png";